import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL+"/api"
});

// REQUEST INTERCEPTOR (optional for token)
api.interceptors.request.use(
  config => {

    const token = localStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;

  },
  error => Promise.reject(error)
);

// RESPONSE INTERCEPTOR
api.interceptors.response.use(

  response => response,

  error => {

    const isLoginRequest = error.config?.url?.includes("/auth/login");

    if (error.response && error.response.status === 401 && !isLoginRequest) {

      // clear session
      localStorage.removeItem("token");

      // redirect to login
      window.location.href = "/login";

    }

    return Promise.reject(error);
  }

);

export default api;